import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-total-active-dicount',
  templateUrl: './tryout-total-active-dicount.component.html',
  styleUrls: ['./tryout-total-active-dicount.component.css']
})
export class TryoutTotalActiveDicountComponent implements OnInit {

  @Input() NoOfTotalActiveDiscount: string;
  @Output() filterProgramsEvent = new EventEmitter();

  //program_status = '';

  constructor() { }

  ngOnInit() {
  }

  //filterProgramListing(value) {
  //  this.program_status = value;
  //  this.filterProgramsEvent.emit(this.program_status);
  //}
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-total-active-dicount/tryout-total-active-dicount.component.ts